import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import Reveal from "./Reveal";

export default function Packages() {
  const { t, link } = useLang();
  const list = t("packages.list");
  return (
    <section data-testid="packages-section" className="bg-white text-ink py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <p className="text-xs font-semibold tracking-[0.25em] text-dblue">{t("packages.eyebrow")}</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">{t("packages.title")}</h2>
          <p className="mt-4 text-base text-slate-600 max-w-xl mx-auto">{t("packages.sub")}</p>
        </Reveal>
        <div className="mt-14 grid gap-6 lg:grid-cols-3 lg:items-stretch">
          {list.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.1} className="h-full">
              <div
                data-testid={`package-${p.name.toLowerCase().replace(/\s/g, "-")}`}
                className={`relative flex h-full flex-col rounded-2xl p-8 transition-transform duration-300 hover:-translate-y-1.5 ${
                  p.highlight
                    ? "bg-ink text-white shadow-[0_30px_80px_-30px_rgba(20,110,245,0.5)] border border-electric/40"
                    : "bg-mist border border-ink/10"
                }`}
              >
                {p.highlight && (
                  <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 rounded-full bg-gradient-to-r from-dblue to-electric px-4 py-1.5 text-[10px] font-bold tracking-[0.2em] text-white whitespace-nowrap">
                    {t("packages.badge")}
                  </span>
                )}
                <h3 className="font-display text-xl font-extrabold tracking-tight">{p.name}</h3>
                <ul className="mt-7 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className={`flex items-start gap-2.5 text-sm ${p.highlight ? "text-white/85" : "text-slate-700"}`}>
                      <Check className={`mt-0.5 h-4 w-4 shrink-0 ${p.highlight ? "text-electric" : "text-dblue"}`} />
                      {f}
                    </li>
                  ))}
                </ul>
                <Link
                  to={link("/contact")}
                  data-testid={`package-cta-${i}`}
                  className={`mt-8 rounded-full px-6 py-3.5 text-center text-sm font-semibold transition-transform duration-200 hover:scale-[1.03] ${
                    p.highlight
                      ? "bg-gradient-to-r from-dblue to-electric text-white"
                      : "border border-ink/20 text-ink hover:bg-ink hover:text-white"
                  }`}
                >
                  {p.highlight ? t("packages.ctaDemo") : t("packages.cta")}
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
